import { createFileRoute } from "@tanstack/react-router";

import Livechat from "../pages/Livechat";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/livechat/")({
  component: LivechatRoute,
});

function LivechatRoute() {
  return (
    <RequireAuth>
      <Livechat />
    </RequireAuth>
  );
}
